import React from 'react';

import { Tooltip } from 'react-tooltip';
import Tags from 'components/Tags/Tags';
import { CardContainerLink, CardTitle } from 'components/CardContainer/CardContainer';
import { ChallengeDescription, CompletionContainer, SponsorImage, SelectedCheckbox } from './styles';

export default function ChallengeCard({
  name,
  description,
  image,
  contestLogo,
  averageRating,
  isCompletedByUser,
  sponsor,
  link,
  thumbnail,
  keywords = [],
  totalCompletions,
  isFreecode,
}) {
  return (
    <CardContainerLink link={link} image={thumbnail ?? image} height={'300px'}>
      {sponsor && contestLogo && <SponsorImage data-tip="Sponsor" src={contestLogo} />}
      {isCompletedByUser && (
        <SelectedCheckbox>
          <i
            className="fa-regular fa-square-check fa-2x"
            aria-hidden="true"
            data-tooltip-id={`completedTipFor${name}`}
            data-tooltip-content="Completed"
            data-tooltip-variant="info"
          ></i>
          <Tooltip id={`completedTipFor${name}`} place="left" className="custom-tooltip" />
        </SelectedCheckbox>
      )}
      <CardTitle name={name} averageRating={averageRating} />
      <ChallengeDescription dangerouslySetInnerHTML={{ __html: description }} />
      {isFreecode && <Tooltip id={`freecode${name}`} place="top" className="custom-tooltip" />}
      <span
        data-tooltip-id={isFreecode && `freecode${name}`}
        data-tooltip-content="Freecodes do not have a correct solution"
        data-tooltip-variant="info"
      >
        <Tags tags={keywords} />
      </span>
      {totalCompletions ? <CompletionContainer>No. of completions: {totalCompletions}</CompletionContainer> : null}
    </CardContainerLink>
  );
}
